import clsx from 'clsx'
import useRequesterContext from 'components/QuestionnaireRequestAutomated/hooks/useRequesterContext'
import SandboxUploadComponent from 'components/utility/sandbox_upload/component'
import React, { useEffect } from 'react'
import { STEP } from '..'
import { FormatFormFile } from 'components/QuestionnaireRequestAutomated/utilities/requester'

const ACCEPTABLE_TYPES = ['.pdf', '.docx', '.doc', '.png', '.jpeg', '.jpg']

export default function UploadFormSection() {
  const { formFile, setFormFile, onNextStep, onBackStep, company, setCompany } = useRequesterContext()

  useEffect(() => {
    setFormFile(null)
  }, [])

  const onChangeCompany = (e) => setCompany({ ...company, name: e.target.value })

  return (
    <div className="form-selection-upload-form-section dome-d-flex dome-flex-column dome-gap18">
      {company.id ? (
        <span className="dome-p1 dome-color-darkest-grey dome-text-w500">upload a form</span>
      ) : (
        <>
          <div className="dome-d-flex dome-flex-column dom-gap6">
            <span className="dome-p1 dome-color-darkest-grey dome-text-w500">upload a form</span>
            <span className="dome-2 dome-color-med-grey">Enter the company name and upload your form. </span>
          </div>
          <div className="dome-d-flex dome-flex-column">
            <span className="dome-p3 dome-color-med-grey">company name</span>
            <input value={company.name} onChange={onChangeCompany} className="form-section-upload-company-name-input" />
          </div>
        </>
      )}
      <SandboxUploadComponent
        multiple={false}
        label="upload blank questionnaire"
        // TODO: Remove when XLS are handled
        accepts={ACCEPTABLE_TYPES}
        onFileRemoved={() => setFormFile(null)}
        onFileProcessed={({ metadata }) =>
          setFormFile(
            FormatFormFile({
              file: metadata,
              pdfUrl: metadata?.urls?.pdf,
              fileName: metadata?.original_filename,
              customForm: true,
            })
          )
        }
      />
      <div className="dome-d-flex dome-align-center dome-justify-between">
        <button
          type="button"
          onClick={onBackStep}
          className="dome-btn dome-btn-link dome-btn-link-med-grey dome-btn-link-chevron-left"
        >
          back
        </button>
        <button
          type="button"
          disabled={!formFile}
          onClick={() => onNextStep(STEP.FORM_REQUEST_INFO)}
          className={clsx('dome-btn dome-btn-base', !formFile ? ' dome-btn-disabled' : 'dome-btn-dark-green')}
        >
          next
        </button>
      </div>
    </div>
  )
}
